
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/salary-survey/submission-success",
      function () {
        return require("private-next-pages/us/salary-survey/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/salary-survey/submission-success"])
      });
    }
  